import { UserAccountType } from "@common/constants/UserAccountType";

export const BETTING_USER_WALLETS = new Set([
	UserAccountType.SportBettingAccountOnline,
	UserAccountType.SportBettingAccountShopOnline,
	UserAccountType.CashToDigitalAccount,
]);
